(function($) {

	let $form = $("form#order-pay-form")

	// Complete order
	function process_payment(e){

		e.preventDefault()

		let url = ghostpress_params.ajax_url + "&action=pay_order",
			data = $(this).serializeArray()

		gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		})
			.done((response, textStatus, jqXHR) => {

				let success = response.success

				if(success){

				}else{
					// Scroll to error notices
					$("html").animate({
						scrollTop: $(".notices").offset().top
					}, 1000);
				}

			})

	}

	$(document).gp_ready(function(){
		$form.off("submit").submit(process_payment)
	})

})(jQuery);